angular.module('impactx.approval').controller('ApprovalUserCtrl', [
    '$scope',
    'ApprovalStatus',
    ApprovalUserController]);

function ApprovalUserController($scope, ApprovalStatus) {
    $scope.statusColor = ApprovalStatus.getStatusColor($scope.status, $scope.externalStep);

    $scope.getBorderStyle = function () {
        if ($scope.onlyOneEntry) {
            return "approval-user-single";
        }
        else if ($scope.isFirstEntry) {
            return 'approval-user-first';
        }
        else if ($scope.isLastEntry) {
            return 'approval-user-last';
        }
        else {
            return 'approval-user';
        }
    };
}